module.exports = __webpack_public_path__ + "assets/img/news-branner-1.c3ed2d1d.png";